<template>
    <img src="/rev-logo.svg" alt="Revolution Logo" width="300" class="mt-2 mb-2 company-logo">
    </img>
</template>


<style lang="css" scoped>
.company-logo {
   filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.18));
    /* animation: CompanyLogoColorSwitch 3s infinite alternate; */
}
</style>